/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { BorrowerMinimalLegalEntityDto } from './BorrowerMinimalLegalEntityDto';
import {
    instanceOfBorrowerMinimalLegalEntityDto,
    BorrowerMinimalLegalEntityDtoFromJSON,
    BorrowerMinimalLegalEntityDtoFromJSONTyped,
    BorrowerMinimalLegalEntityDtoToJSON,
} from './BorrowerMinimalLegalEntityDto';
import type { BorrowerMinimalNaturalPersonDto } from './BorrowerMinimalNaturalPersonDto';
import {
    instanceOfBorrowerMinimalNaturalPersonDto,
    BorrowerMinimalNaturalPersonDtoFromJSON,
    BorrowerMinimalNaturalPersonDtoFromJSONTyped,
    BorrowerMinimalNaturalPersonDtoToJSON,
} from './BorrowerMinimalNaturalPersonDto';

/**
 * @type BorrowerMinimalPersonDto
 * 
 * @export
 */
export type BorrowerMinimalPersonDto = { type: 'morale' } & BorrowerMinimalLegalEntityDto | { type: 'physique' } & BorrowerMinimalNaturalPersonDto;

export function BorrowerMinimalPersonDtoFromJSON(json: any): BorrowerMinimalPersonDto {
    return BorrowerMinimalPersonDtoFromJSONTyped(json, false);
}

export function BorrowerMinimalPersonDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerMinimalPersonDto {
    if (json == null) {
        return json;
    }
    switch (json['type']) {
        case 'morale':
            return Object.assign({}, BorrowerMinimalLegalEntityDtoFromJSONTyped(json, true), { type: 'morale' } as const);
        case 'physique':
            return Object.assign({}, BorrowerMinimalNaturalPersonDtoFromJSONTyped(json, true), { type: 'physique' } as const);
        default:
            throw new Error(`No variant of BorrowerMinimalPersonDto exists with 'type=${json['type']}'`);
    }
}

export function BorrowerMinimalPersonDtoToJSON(json: any): any {
    return BorrowerMinimalPersonDtoToJSONTyped(json, false);
}

export function BorrowerMinimalPersonDtoToJSONTyped(value?: BorrowerMinimalPersonDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    switch (value['type']) {
        case 'morale':
            return Object.assign({}, BorrowerMinimalLegalEntityDtoToJSON(value), { type: 'morale' } as const);
        case 'physique':
            return Object.assign({}, BorrowerMinimalNaturalPersonDtoToJSON(value), { type: 'physique' } as const);
        default:
            throw new Error(`No variant of BorrowerMinimalPersonDto exists with 'type=${value['type']}'`);
    }

}

